import { useCallback, useEffect, useRef } from 'react'

const useTimeout = (defaultDelay = 0) => {
  const toRef = useRef()
  const launch = useCallback(
    (fn, delay = defaultDelay) => {
      clearTimeout(toRef.current)
      toRef.current = setTimeout(fn, delay)
    },
    [defaultDelay]
  )

  const stop = useCallback(() => {
    clearTimeout(toRef.current)
    toRef.current = undefined
  }, [])

  const isPending = () => Boolean(toRef.current)

  useEffect(() => {
    return () => {
      stop()
    }
  }, [])

  return [launch, stop, isPending]
}

export default useTimeout
